<template>
  <router-link
    :to="to"
    class="relative flex items-center rounded-lg text-sm font-medium transition-colors group"
    :class="[
      collapsed ? 'justify-center px-2 py-2.5' : 'gap-3 px-3 py-2',
      isActive ? 'bg-blue-600 text-white' : 'text-gray-400 hover:bg-gray-800 hover:text-white',
    ]"
  >
    <component :is="iconComponent" class="w-5 h-5 shrink-0" />
    <span v-if="!collapsed" class="truncate">{{ label }}</span>

    <span
      v-if="collapsed"
      class="pointer-events-none absolute left-full ml-3 px-2.5 py-1.5 rounded-md bg-gray-800 text-white text-xs whitespace-nowrap opacity-0 group-hover:opacity-100 transition-opacity duration-150 shadow-lg z-50"
    >
      {{ label }}
    </span>
  </router-link>
</template>

<script setup lang="ts">
  import { computed } from 'vue';
  import { useRoute } from 'vue-router';
  import { CalendarIcon, ClipboardListIcon, ClockIcon, KeyIcon, OfficeBuildingIcon, TagIcon, TruckIcon, UploadIcon } from './icons';

  const props = defineProps<{
    to: string;
    icon: string;
    label: string;
    collapsed?: boolean;
  }>();

  const route = useRoute();
  const isActive = computed(() => (props.to === '/' ? route.path === '/' : route.path.startsWith(props.to)));

  const iconMap: Record<string, typeof OfficeBuildingIcon> = {
    'office-building': OfficeBuildingIcon,
    upload: UploadIcon,
    calendar: CalendarIcon,
    tag: TagIcon,
    key: KeyIcon,
    'clipboard-list': ClipboardListIcon,
    clock: ClockIcon,
    truck: TruckIcon,
  };

  const iconComponent = computed(() => iconMap[props.icon] ?? OfficeBuildingIcon);
</script>
